import CommonStyles from "..";
import { EAppointmentType, EServiceChannel } from "@base/enums";

interface IProps {
  type: EAppointmentType;
  /** Set for a package booking: names where the service happens rather than online/offline. */
  channel?: EServiceChannel;
}

const OFFLINE_CLASS_NAME = "bg-common-blue100 border-common-blue600 text-common-blue600 max-sm:line-clamp-1";
/** Every online appointment - booked from a package or not - reads the same. */
const ONLINE_CONSULTATION_CLASS_NAME = "bg-common-green500 border-common-green500 text-common-white max-sm:line-clamp-1";
const HOME_CLASS_NAME = "bg-common-purple100 border-common-purple500 text-common-purple500 max-sm:line-clamp-1";

const getChannelTag = (channel: EServiceChannel) => {
  switch (channel) {
    case EServiceChannel.HOME:
      return { tagName: "Tại nhà", className: HOME_CLASS_NAME };
    case EServiceChannel.FACILITY:
      return { tagName: "Tại cơ sở y tế", className: OFFLINE_CLASS_NAME };
    case EServiceChannel.ONLINE:
      return { tagName: "Tư vấn trực tuyến", className: ONLINE_CONSULTATION_CLASS_NAME };
    case EServiceChannel.HOME_OR_FACILITY:
      return { tagName: "Tại nhà hoặc tại CSYT", className: HOME_CLASS_NAME };
  }
};

export default function TagAppointmentType({ type, channel }: IProps) {
  //! state
  const { tagName, className } = channel
    ? getChannelTag(channel)
    : type === EAppointmentType.ONLINE
      ? { tagName: "Tư vấn trực tuyến", className: ONLINE_CONSULTATION_CLASS_NAME }
      : { tagName: "Tại cơ sở y tế", className: OFFLINE_CLASS_NAME };

  //! render
  return <CommonStyles.TagUI tagName={tagName} className={className} />;
}
